import { Provider as ConfirmationProvider } from './context'
import useConfirmation from './useConfirmation'

export { ConfirmationProvider, useConfirmation }
